import React, { useEffect } from "react";
import JobOrders from "../Concerns/Concerns";
import WaterMeterReading from "./WaterMeterReading";
import { useSearchParams } from "react-router-dom";
import Maintenance from "../Maintenance/Maintenance";
import MaintenanceNewPage from "../Maintenance/MaintenanceNewPage";
import WorkWeekSchedule from "../WorkWeek/WorkWeekSchedule";
import FiftyTwoWorkWeekSchedulePage from "./FiftyTwoWorkWeekSchedulePage";
import ParcelAdminPage from "./ParcelAdminPage";
import WorkPermits from "../WorkPermits/WorkPermits";
import ServiceRequests from "./ServiceRequests";

function PropertyManagement() {
  const [activeLink, setActiveLink] = React.useState("Work Permits");
  const [searchParams, setSearchParams] = useSearchParams();

  const searchType = searchParams.get("type");

  const links = [
    "Work Permits",
    "Concerns",
    "Service Requests",
    "Parcels",
    "Maintenance",
    "Water Meter Reading",
    "52 Work Week Schedule",
  ];

  useEffect(() => {
    if (searchType) {
      setActiveLink(searchType);
    }
  }, []);

  useEffect(() => {
    setSearchParams({ type: activeLink });
  }, [activeLink]);

  return (
    <div className="p-2 text-xs max-w-7xl mx-auto">
      <div className="font-medium text-lg text-gray-900 text-left mt-4">
        Property Management
      </div>
      <div className="links-container mt-4">
        {links.map((link, index) => (
          <div
            key={index}
            className={`${
              activeLink === link ? "activeLinkStyle" : "inactiveLinkStyle"
            } cursor-pointer`}
            onClick={() => setActiveLink(link)}
          >
            {link}
          </div>
        ))}
      </div>
      <div className="mt-8 text-gray-600">
        {
          {
            "Work Permits": <WorkPermits />,
            Concerns: <JobOrders />,
            Parcels: <ParcelAdminPage />,
            "Water Meter Reading": <WaterMeterReading />,
            Maintenance: <MaintenanceNewPage />,
            "52 Work Week Schedule": <FiftyTwoWorkWeekSchedulePage />,
            "Service Requests": <ServiceRequests />,
          }[activeLink]
        }
      </div>
    </div>
  );
}

export default PropertyManagement;
